import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import BrandMark from './BrandMark';

export default function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-screen w-full bg-[#0D0518] bg-grid-pattern overflow-hidden relative">
      {/* Ambient background glows */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-violet-900/30 blur-[120px] rounded-full pointer-events-none"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[30%] h-[30%] bg-cyan-400/5 blur-[100px] rounded-full pointer-events-none"></div>
      
      <Sidebar />
      
      <div className="flex-1 flex flex-col h-full relative z-10 w-full overflow-hidden">
        <Topbar onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)} />
        
        <main className="flex-1 overflow-auto scrollbar-custom p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
        
        <footer className="h-10 flex items-center justify-between px-8 border-t border-matrix-border/20 glass-panel bg-[#0D0518]/80">
          <div className="flex items-center gap-2 opacity-40 hover:opacity-100 transition-opacity grayscale hover:grayscale-0">
            <BrandMark className="w-4 h-4" />
            <span className="text-[10px] text-gray-400 font-mono uppercase tracking-widest">
              MeetMatrix System
            </span>
          </div>
          <span className="text-[9px] text-gray-600 font-mono uppercase tracking-[0.3em]">
            Made by LingLink AI and DigLab AI
          </span>
          <div className="text-[10px] text-gray-500 font-mono">
            SECURE PORT: 8080
          </div>
        </footer>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md md:hidden flex">
          <div className="w-64 h-full bg-[#0D0518] border-r border-cyan-400/20">
            <Sidebar />
          </div>
          <div className="flex-1" onClick={() => setMobileMenuOpen(false)}></div>
        </div>
      )}
    </div>
  );
}